import gql from 'graphql-tag';

export const LOGIN = gql`
	mutation authLoginMutation($input: AuthLoginInput!) {
		authLogin(input: $input) {
			id
			value
		}
	}
`;

export const CHANGE_PASSWORD = gql`
	mutation changePassword($id: ID!, $password: String!, $newPassword: String!) {
		changePassword(id: $id, password: $password, newPassword: $newPassword)
	}
`;

export const RESET_PASSWORD = gql`
	mutation resetPasswordMutation($email: String!, $appId: Int) {
		resetPassword(email: $email, appId: $appId)
	}
`;

export const SET_NEW_PASSWORD = gql`
	mutation setNewPasswordMutation($token: String!, $password: String!, $appId: Int) {
		setNewPassword(token: $token, password: $password, appId: $appId)
	}
`;

export const SEND_NEW_EMAIL_CODE = gql`
mutation sendNewEmailCodeMutation($email: String!, $newEmail: String!, $appId: Int) {
	sendNewEmailCode(email: $email, newEmail: $newEmail, appId: $appId) {
		code
	}
}
`;
